import { FC } from 'react';
import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import Modal from '@/components/Modal/Modal';
import styles from './LockBundleModal.module.css';
import { useTranslation } from 'react-i18next';

interface LockBundleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  headerText?: string;
  bodyText?: string;
  confirmText?: string;
}

const LockBundleModal: FC<LockBundleModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  headerText,
  bodyText,
  confirmText,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      className={styles.modal}
      headerContent={<div className={styles.header}>{headerText}</div>}
      showTitleDivider
      footerContent={
        <div className={styles.footer}>
          <div className={styles.footerButtons}>
            <Button onClick={onClose} variant={ButtonVariants.Secondary} data-testId="cancelButton">
              {t('common.cancel')}
            </Button>
            <Button onClick={onConfirm} isLoading={isLoading} data-testId="confirmButton">
              {confirmText}
            </Button>
          </div>
        </div>
      }
      onClose={onClose}
      isOpen={isOpen}
      bodyContent={
        <div className={styles.body}>
          <p>{bodyText}</p>
        </div>
      }
    />
  );
};

export default LockBundleModal;
